import React, { useEffect, useRef, useState, useContext } from 'react'
import { Container, Row } from 'react-bootstrap'
import './WeExpress.css'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import AOS from "aos";
import "aos/dist/aos.css";
import { Context } from "../../../utils/context";
import { Gratitude } from "../../../utils/apis/master/Master";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const WeExpress = ({ data }) => {
    const weExprss = [
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/hp_logo.png",

        },
        {


            image: process.env.PUBLIC_URL + "/assest/image/home/samsung.png",

        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/lg-company.png",
        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/asian-paints.png",
        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/hp_logo.png",

        },
        {


            image: process.env.PUBLIC_URL + "/assest/image/home/samsung.png",

        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/lg-company.png",
        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/asian-paints.png",
        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/hp_logo.png",

        },
        {


            image: process.env.PUBLIC_URL + "/assest/image/home/samsung.png",

        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/lg-company.png",
        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/asian-paints.png",
        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/hp_logo.png",

        },
        {


            image: process.env.PUBLIC_URL + "/assest/image/home/samsung.png",

        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/lg-company.png",
        },
        {

            image: process.env.PUBLIC_URL + "/assest/image/home/asian-paints.png",
        },
    ];
    useEffect(() => {
        AOS.init({ once: true });
    }, []);
    const { IMG_URL } = useContext(Context);


    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 9,
        slidesToScroll: 1,
        autoplay: true,
        speed: 10000,
        autoplaySpeed: 0,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 8,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 6,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
            }
          }
        ]
      };
      

    return (
        <>
            <section className='we-express'>
                <div className='custom_container' data-aos="fade-up"
                    data-aos-duration="3000">
                    <Row>
                        <div className='heading-holder'>
                            {/* <h2>Privileged to serve our customers</h2>  */}
                            <div className='d-flex justify-content-center'>
                                <h2 className='first-heading'>Privileged to Serve </h2>
                                <h3 className='second-heading'>Our Customers</h3>
                            </div>
                            {/* <p>Your Trust Drives Our Success.</p> */}
                        </div>


                        {/* <Swiper
                            loop={true} 
                            slidesPerView="auto" 
                            spaceBetween={30} 
                            centeredSlides={false}
                            breakpoints={{
                                0: { slidesPerView: 4, spaceBetween: 5 },
                                486: { slidesPerView: 5, spaceBetween: 20 },
                                768: { slidesPerView: 6, spaceBetween: 20 },
                                992: { slidesPerView: 8, spaceBetween: 20 },
                                1200: { slidesPerView: 10, spaceBetween: 30 },
                                1400: { slidesPerView: 8, spaceBetween: 20 },
                            }}
                            pagination={{
                                dynamicBullets: true,
                                clickable: true,
                            }}
                            autoplay={{
                                delay: 0, 
                                disableOnInteraction: false, 
                            }}
                            speed={5000} 
                            allowTouchMove={false}
                            className="mySwiper"
                        >
                            {data?.length > 0 ? (
                                [...data, ...data].map((item, index) => ( 
                                    <SwiperSlide key={index}>
                                        <div className="main-div">
                                            <div className="image-holder">
                                                <img src={IMG_URL + item?.image} className="company-logo" alt="" />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))
                            ) : (
                                <div className="no-data">
                                    <p style={{ textAlign: "center", fontWeight: "bold", margin: 0 }}>
                                        No data available
                                    </p>
                                </div>
                            )}
                        </Swiper> */}

                        {/* <div className='imgs_holder'>
                            {data?.length > 0 ? (
                                [...data, ...data].map((item, index) => (
                                    <img src={IMG_URL + item?.image} className="company-logo" alt="" />
                                ))
                            ) : (
                                <div className="no-data">
                                    <p style={{ textAlign: "center", fontWeight: "bold", margin: 0 }}>
                                        No data available
                                    </p>
                                </div>
                            )}
                        </div> */}

                        <div className="slider-container">
                            <Slider {...settings}>
                                {data?.length > 0 ? (
                                    [...data, ...data].map((item, index) => (
                                        <img src={IMG_URL + item?.image} className="company-logo" alt="" />
                                    ))
                                ) : (
                                    <div className="no-data">
                                        <p style={{ textAlign: "center", fontWeight: "bold", margin: 0 }}>
                                            No data available
                                        </p>
                                    </div>
                                )}
                            </Slider>
                        </div>


                    </Row>
                </div>
            </section>
        </>
    )
}

export default WeExpress
